import React from 'react';
import { Element } from 'react-scroll';
import Navbar from './NavBar';
import Home from './Sections/Home';
import Education from './Sections/Education';
import Experience from './Sections/Experience';
import Projects from './Sections/Projects';
import Skills from './Sections/Skills';
import Contact from './Sections/Contact';

const Portfolio = () => {
  return (
    <div className="font-sans">
      <Navbar />
      <div className="pt-16">
        <Element name="home">
          <Home />
        </Element>
        <Element name="education">
          <Education />
        </Element>
        <Element name="work">
          <Experience />
        </Element>
        <Element name="projects">
          <Projects />
        </Element>
        <Element name="skills">
          <Skills />
        </Element>
        <Element name="contact">
          <Contact />
        </Element>
      </div>
    </div>
  );
};

export default Portfolio;
